import React from 'react'
import Helmet from 'react-helmet'

const Head = ({ lang = 'en' }) => (
  <>
    <Helmet>
      <meta charset="utf-8" />
      <meta http-equiv="x-ua-compatible" content="ie=edge" />
      <meta name="theme-color" content="#ffffff" />
      <meta
        name="google-site-verification"
        content="BAzejNes6jkyzQKvMYT03F2V88kSzzkOe7EE6JaoVbw"
      />

      {/* Icons */}
      <link
        rel="apple-touch-icon"
        sizes="120x120"
        href="/img/apple-icon-120x120.png"
      />
      <link
        rel="icon"
        href="/uploads/2018/03/cropped-C_Users_pavel_AppData_Local_Packages_Microsoft.SkypeApp_kzf8qxf38zg5c_LocalState_076db00e-8644-4579-b33f-d40dc8bc3c67-32x32.png"
        sizes="32x32"
      />
      <link
        rel="icon"
        href="/uploads/2018/03/cropped-C_Users_pavel_AppData_Local_Packages_Microsoft.SkypeApp_kzf8qxf38zg5c_LocalState_076db00e-8644-4579-b33f-d40dc8bc3c67-192x192.png"
        sizes="192x192"
      />
    </Helmet>
  </>
)

export default Head
